import { mapValues } from 'lodash';
import { QueryOperator } from '@moleculeone/types';

import { styled } from '../../../stitches.config';
import { OperatorSidebar, OperatorContainer } from './Operator';
import { Body } from './Body';
import { Row } from './Row';

const OPERATOR_COLORS = {
  [QueryOperator.AND]: 'red',
  [QueryOperator.OR]: 'green',
};

type OperatorStyles = { [key in keyof typeof QueryOperator]: any };

export const Container = styled('div', {
  display: 'flex',
  flexGrow: 1,
  variants: {
    operator: mapValues(OPERATOR_COLORS, color => {
      return {
        [`& > ${OperatorSidebar} > ${OperatorContainer}`]: {
          backgroundColor: `$${color}4`,
          borderColor: `$${color}8`,
        },
        [`& > ${OperatorSidebar} ${OperatorContainer} button`]: {
          color: `$${color}10`,
        },
        [`& > ${OperatorSidebar} ${OperatorContainer} button > *`]: {
          color: `$${color}10`,
        },
        [`& > ${OperatorSidebar} ${OperatorContainer} button:hover`]: {
          backgroundColor: `$${color}6`,
        },
        [`& > ${OperatorSidebar} ${OperatorContainer} button[data-state="open"]`]: {
          backgroundColor: `$${color}7`,
        },
        [`& > ${Body} > ${Row}::before`]: {
          borderColor: `$${color}8`,
        },
      };
    }) as OperatorStyles,
  },
});
